import { checkoutService } from '@afterpaytouch/portal-api/consumer/checkout'

export const { useLazyGetOrderIdByTokenQuery } = checkoutService
